import {EventEmitter, Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Level} from '../../classes/level/level';
import {distinctUntilChanged, skip} from 'rxjs/operators';
import {BehaviorSubject, ReplaySubject, Subject} from 'rxjs';
import {Project} from '../../classes/project/project';
import {stringify} from 'querystring';
import {LevelService} from '../level/level.service';

@Injectable({
  providedIn: 'root'
})
export class StatesService {


  public selectedProject: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public stateLevel: number;
  public stateLanguage: string;
  public languageChanged: Subject<number> = new Subject();
  public stateLevelSubject: ReplaySubject<Level> = new ReplaySubject(1);
  public stateLevelChangedSubject: Subject<number> = new Subject();
  public reloadListLevel: Subject<number> = new Subject();
  public reloadListUser: Subject<number> = new Subject();
  public reloadListDevices: Subject<number> = new Subject();
  public reloadListMathsNaive: Subject<number> = new Subject();
  public reloadLevelSelector: Subject<number> = new Subject();
  public reloadListProject: Subject<number> = new Subject();
  public reloadDeviceCrud: Subject<number> = new Subject();
  public reloadProjectCrud: Subject<number> = new Subject();
  public reloadProjectUserRemove: Subject<number> = new Subject();
  public reloadProjectLocation: Subject<number> = new Subject();
  public reloadProjectDevice: Subject<number> = new Subject();
  public reloadProjectAlarmsUserRemove: Subject<number> = new Subject();
  public reloadProjectAlarmsLocationRemove: Subject<number> = new Subject();
  public reloadProjectAlarms: Subject<number> = new Subject();
  public updateProjectsFromList: EventEmitter<Project[]> = new EventEmitter();

  constructor() {
    const currentUser = this.getCurrentUser();
    if (currentUser && currentUser.level.id) {
      this.stateLevel = this.getSelectedLevelId();
    }
    if (currentUser) {
      this.stateLanguage = currentUser.lang;
    } else {
      this.stateLanguage = 'en';
    }
    this.stateLevelSubject.subscribe(
      (level) => {
        if (!level) {
          return;
        }
        this.stateLevelChangedSubject.next();
        localStorage.setItem(environment.levelLocalStored + this.getCurrentUser().id, JSON.stringify(level.id));
      }
    );
  }

  getSelectedLevelId() {
    const currentUser = this.getCurrentUser();
    return JSON.parse(localStorage.getItem(environment.levelLocalStored + currentUser.id)) || currentUser.level.id;
  }

  private getCurrentUser() {
    return JSON.parse(localStorage.getItem(environment.userLocalStored));
  }

}
